module.exports = __webpack_public_path__ + "static/media/handoff-start.8d9460e5.png";